import { combineReducers } from 'redux';
import {
  CLOSE_LOANS_DRAWER,
  FETCH_LOANS,
  FETCH_LOANS_SUCCESS,
  OPEN_LOANS_DRAWER,
} from './constants';

const list = (state = [], action) => {
  switch (action.type) {
    case FETCH_LOANS:
      return [];
    case FETCH_LOANS_SUCCESS:
      return action.payload.filter(item => !item.isDeleted);
    default:
      return state;
  }
};

const deletedList = (state = [], action) => {
  switch (action.type) {
    case FETCH_LOANS:
      return [];
    case FETCH_LOANS_SUCCESS:
      return action.payload.filter(item => item.isDeleted);
    default:
      return state;
  }
};

const initialLoansLoadDone = (state = false, action) => {
  switch (action.type) {
    case FETCH_LOANS_SUCCESS:
      return true;
    default:
      return state;
  }
};

const drawerOpened = (state = false, action) => {
  switch (action.type) {
    case OPEN_LOANS_DRAWER:
      return true;
    case CLOSE_LOANS_DRAWER:
      return false;
    default:
      return state;
  }
};

const loansReducers = combineReducers({
  drawerOpened,
  list,
  deletedList,
  initialLoansLoadDone,
});

export default loansReducers;
